import React, { useEffect, useState } from "react";
import DatePicker from "react-date-picker";
import { useForm, Controller } from "react-hook-form";
import "react-date-picker/dist/DatePicker.css";
import cn from "classnames";
import styles from "./TripAndCharge.module.scss";
import moment, { utc } from "moment";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import $ from "jquery";
import Select from "react-select";
// import {sliderData} from "../sliderData";
import Constants from "../common/Constants";
let {
  error: {
    scheduleDateError,
    endOfTripError,
    departureTimeRequired,
    arrivalTimeRequired,
    dayOfWeekRequired,
    desiredChargedLevelRequired,
    arrivalTimeMustBeGreaterThanDepartureTime,
    arrivalTimeAndDepartureTimeMustBeWithInSameDay,
  },
} = Constants;

function TripPopup(props) {
  // console.log(props.chargetrip)
  // console.log(props)
  const chargerid = props.chargerid;
  var recID;
  let unitsSystem = process.env.REACT_APP_UNITS_SYSTEM;
  let checkBoxCheked =
    props.chargetrip === "Charging Schedule" ? "Recurring" : "oneTime";

  //   const [startDate, setStartDate] = useState(new Date());
  const [startDate, setStartDate] = useState(null);

  // console.log('s', startDate)
  const [startDateError, setStartDateError] = useState("");

  //   const [endDate, setEndDate] = useState(new Date());

  const [endDate, setEndDate] = useState(null);

  const [endDateError, setEndDateError] = useState("");

  const [arrivalTimeError, setArrivalTimeError] = useState("");

  const [onetimestate, setoneTimeState] = useState(checkBoxCheked);
  const [percentage, setProgressValue] = useState(0);
  const [percentageError, setPercentageError] = useState("");

  const [selectSun, setSelectSun] = useState(false);
  const [selectMon, setSelectMon] = useState(false);
  const [selectTue, setselectTue] = useState(false);
  const [selectWed, setselectWed] = useState(false);
  const [selectThu, setselectThu] = useState(false);
  const [selectFri, setselectFri] = useState(false);
  const [selectSat, setselectSat] = useState(false);

  const [recurringError, setRecurringError] = useState("");
  const [disableEditTripSchedule, setDisableEditTripSchedule] = useState(true);

  // const checkTime=[

  // ]
  // const checkTime = new Map();
  // checkTime.set('01:01', 1); checkTime.set(3, 2); checkTime.set(5, 3); checkTime.set(7, 4);
  const minsArray = [
    { min: "00", value: "00" },
    { min: "01", value: "01" },
    { min: "02", value: "02" },
    { min: "03", value: "03" },
    { min: "04", value: "04" },
    { min: "05", value: "05" },
    { min: "06", value: "06" },
    { min: "07", value: "07" },
    { min: "08", value: "08" },
    { min: "09", value: "09" },
    { min: "10", value: "10" },
    { min: "11", value: "11" },
    { min: "12", value: "12" },
    { min: "13", value: "13" },
    { min: "14", value: "14" },
    { min: "15", value: "15" },
    { min: "16", value: "16" },
    { min: "17", value: "17" },
    { min: "18", value: "18" },
    { min: "19", value: "19" },
    { min: "20", value: "20" },
    { min: "21", value: "21" },
    { min: "22", value: "22" },
    { min: "23", value: "23" },
    { min: "24", value: "24" },
    { min: "25", value: "25" },
    { min: "26", value: "26" },
    { min: "27", value: "27" },
    { min: "28", value: "28" },
    { min: "29", value: "29" },
    { min: "30", value: "30" },
    { min: "31", value: "31" },
    { min: "32", value: "32" },
    { min: "33", value: "33" },
    { min: "34", value: "34" },
    { min: "35", value: "35" },
    { min: "36", value: "36" },
    { min: "37", value: "37" },
    { min: "38", value: "38" },
    { min: "39", value: "39" },
    { min: "40", value: "40" },
    { min: "41", value: "41" },
    { min: "42", value: "42" },
    { min: "43", value: "43" },
    { min: "44", value: "44" },
    { min: "45", value: "45" },
    { min: "46", value: "46" },
    { min: "47", value: "47" },
    { min: "48", value: "48" },
    { min: "49", value: "49" },
    { min: "50", value: "50" },
    { min: "51", value: "51" },
    { min: "52", value: "52" },
    { min: "53", value: "53" },
    { min: "54", value: "54" },
    { min: "55", value: "55" },
    { min: "56", value: "56" },
    { min: "57", value: "57" },
    { min: "58", value: "58" },
    { min: "59", value: "59" },
  ];
  let percentSteps = 0;
  let milege;

  const map1 = new Map();
  map1.set(1, 1);
  map1.set(3, 2);
  map1.set(5, 3);
  map1.set(7, 4);
  map1.set(9, 5);
  map1.set(13, 7);
  map1.set(37, 19);
  map1.set(51, 26);
  map1.set(15, 8);
  map1.set(17, 9);
  map1.set(39, 20);
  map1.set(53, 27);
  map1.set(19, 10);
  map1.set(21, 11);
  map1.set(41, 21);
  map1.set(54, 28);
  map1.set(23, 12);
  map1.set(25, 13);
  map1.set(43, 22);
  map1.set(55, 29);
  map1.set(27, 14);
  map1.set(29, 15);
  map1.set(45, 23);
  map1.set(56, 30);
  map1.set(31, 16);
  map1.set(33, 17);
  map1.set(47, 24);
  map1.set(57, 31);
  map1.set(11, 6);
  map1.set(35, 18);
  map1.set(49, 25);
  map1.set(58, 32);
  map1.set(59, 33);
  map1.set(67, 41);
  map1.set(75, 49);
  map1.set(83, 57);
  map1.set(60, 34);
  map1.set(68, 42);
  map1.set(76, 50);
  map1.set(84, 58);
  map1.set(61, 35);
  map1.set(69, 43);
  map1.set(77, 51);
  map1.set(85, 59);
  map1.set(62, 36);
  map1.set(70, 44);
  map1.set(78, 52);
  map1.set(86, 60);
  map1.set(63, 37);
  map1.set(71, 45);
  map1.set(79, 53);
  map1.set(87, 61);
  map1.set(64, 38);
  map1.set(72, 46);
  map1.set(80, 54);
  map1.set(88, 62);
  map1.set(65, 39);
  map1.set(73, 47);
  map1.set(81, 55);
  map1.set(89, 63);
  map1.set(66, 40);
  map1.set(74, 48);
  map1.set(82, 56);
  map1.set(90, 64);
  map1.set(91, 65);
  map1.set(94, 68);
  map1.set(97, 71);
  map1.set(100, 74);
  map1.set(92, 66);
  map1.set(95, 69);
  map1.set(98, 72);
  map1.set(93, 67);
  map1.set(96, 70);
  map1.set(99, 73);
  const [dataList, setDataList] = useState([]);
  let addclick = props.addClick;
  const recurringCharger = () => {
    if (checkBoxCheked === "Recurring") {
      // debugger
      if (addclick === "addData") {
        let sdate = new Date();
        let date = sdate.setDate(sdate.getDate() + 7);
        setEndDate(new Date(date));
      } else {
        if (props.data[1] > 1000) {
          let date = props?.data[6];
          // let date = startDate.setDate(startDate.getDate() + 7);
          setEndDate(new Date(date));
        }
      }
    } else {
      // let date = startDate;
      // setEndDate(new Date(date))
    }
  };

  let recurringdate;
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    control,
    formState: { errors },

    // formState: { errors, isDirty, dirtyFields },
  } = useForm();

  let typeRecurring = onetimestate;
  const onSubmit = (data) => {
    let { startDate, endDate } = data;
    // debugger
    setStartDateError("");
    console.log("dataaaaa", data);
    setEndDateError("");
    setPercentageError("");
    setRecurringError("");
    setArrivalTimeError("");
    // if (!startDate) {
    //   setStartDateError("Please select the start date");
    //   return;
    // }
    // if (!endDate) {
    //   setEndDateError("Please select the end date");
    //   return;
    // }

    // debugger
    if (endDate < startDate) {
      setEndDateError("End of Trip Date cannot be before Schedule Date");
      return false;
    }

    if (!percentage) {
      setPercentageError(desiredChargedLevelRequired);
      return;
    }

    let startDatewithAppendTime = new Date(startDate);

    let scheduleDateStartHour = Number(data.startHours);
    if (data.sAmPm === "pm" && scheduleDateStartHour < 12) {
      scheduleDateStartHour = scheduleDateStartHour + 12;
    }
    if (data.sAmPm === "am" && scheduleDateStartHour === 12) {
      scheduleDateStartHour = scheduleDateStartHour - 12;
    }

    startDatewithAppendTime.setHours(scheduleDateStartHour.toString());
    startDatewithAppendTime.setMinutes(data.startMin);
    startDatewithAppendTime.setSeconds(0);
    startDatewithAppendTime.setMilliseconds(0);

    let endOfTimewithAppendTime = new Date(endDate);

    let endOfTimeDateEndHour = Number(data.endHours);
    if (data.eAmPm === "pm" && endOfTimeDateEndHour < 12) {
      endOfTimeDateEndHour = endOfTimeDateEndHour + 12;
    }
    if (data.eAmPm === "am" && endOfTimeDateEndHour === 12) {
      endOfTimeDateEndHour = endOfTimeDateEndHour - 12;
    }

    endOfTimewithAppendTime.setHours(endOfTimeDateEndHour.toString());
    endOfTimewithAppendTime.setMinutes(data.endMin);
    endOfTimewithAppendTime.setSeconds(0);
    endOfTimewithAppendTime.setMilliseconds(0);

    if (endOfTimewithAppendTime <= startDatewithAppendTime) {
      setArrivalTimeError(arrivalTimeMustBeGreaterThanDepartureTime);
      return false;
    }

    if (typeRecurring !== "oneTime") {
      // In case of recurring start time and endofTime must be with in same day . Next day is not allowed
      let startTodayDateForRecurring = new Date();

      let todayTimeStartHour = Number(data.startHours);
      if (data.sAmPm === "pm" && todayTimeStartHour < 12) {
        todayTimeStartHour = todayTimeStartHour + 12;
      }
      if (data.sAmPm === "am" && todayTimeStartHour === 12) {
        todayTimeStartHour = todayTimeStartHour - 12;
      }

      startTodayDateForRecurring.setHours(todayTimeStartHour.toString());
      startTodayDateForRecurring.setMinutes(data.startMin);
      startTodayDateForRecurring.setSeconds(0);
      startTodayDateForRecurring.setMilliseconds(0);

      let endOfTodayTimeForRecurring = new Date();

      let todayTimeEndHour = Number(data.endHours);
      if (data.eAmPm === "pm" && todayTimeEndHour < 12) {
        todayTimeEndHour = todayTimeEndHour + 12;
      }
      if (data.eAmPm === "am" && todayTimeEndHour === 12) {
        todayTimeEndHour = todayTimeEndHour - 12;
      }

      endOfTodayTimeForRecurring.setHours(todayTimeEndHour.toString());
      endOfTodayTimeForRecurring.setMinutes(data.endMin);
      endOfTodayTimeForRecurring.setSeconds(0);
      endOfTodayTimeForRecurring.setMilliseconds(0);

      if (endOfTodayTimeForRecurring <= startTodayDateForRecurring) {
        setArrivalTimeError(arrivalTimeAndDepartureTimeMustBeWithInSameDay);
        return false;
      }

      if (
        !selectSun &&
        !selectMon &&
        !selectTue &&
        !selectWed &&
        !selectThu &&
        !selectFri &&
        !selectSat
      ) {
        setRecurringError(dayOfWeekRequired);
        return;
      }
    }

    console.log("Workeddataa");

    const tempArray = [...dataList, data];
    setDataList(tempArray);
    let sdd = String(startDate.getDate()).padStart(2, "0");
    let smm = String(startDate.getMonth() + 1).padStart(2, "0");
    let syyyy = startDate.getFullYear();
    let sours = tempArray[0].startHours;
    let smin = tempArray[0].startMin;
    let sAmPm = tempArray[0]?.sAmPm;
    // let fromdate = syyyy + "-" + smm + "-" + sdd + "T" + sours + ":" + smin;

    let fromdate;

    if (unitsSystem === "metric") {
      fromdate = syyyy + "-" + smm + "-" + sdd + "T" + sours + ":" + smin;
    } else {
      let hours;
      if (sAmPm === "pm") {
        hours = sours == "12" ? sours : 12 + parseInt(sours);
      } else {
        hours = sours == "12" ? "00" : sours;
      }
      fromdate = syyyy + "-" + smm + "-" + sdd + "T" + hours + ":" + smin;
    }
    let fsromdate = syyyy + "-" + smm + "-" + sdd + "T";
    let edd = String(endDate.getDate()).padStart(2, "0");
    let emm = String(endDate.getMonth() + 1).padStart(2, "0");
    let eyyyy = endDate.getFullYear();
    let ehours = tempArray[0].endHours;
    let emin = tempArray[0].endMin;
    let eAmPm = tempArray[0]?.eAmPm;
    // if(sAmPm==='pm'){
    //     let hours=i===11?12+i:12+i+1;
    //     startTime=hours.toString() + ":" + smin + ":00"
    //     priviousto=hours + ":" + smin + ":00"
    // }else{
    //     priviousto = sours + ":" + smin + ":00"
    //     startTime=sours + ":" + smin + ":00"
    // }
    // let todate = eyyyy + "-" + emm + "-" + edd + "T" + ehours + ":" + emin;
    let todate;
    if (unitsSystem === "metric") {
      todate = eyyyy + "-" + emm + "-" + edd + "T" + ehours + ":" + emin;
    } else {
      let hours;
      if (eAmPm === "pm") {
        hours = ehours == "12" ? ehours : 12 + parseInt(ehours);
      } else {
        hours = ehours == "12" ? "00" : ehours;
      }
      todate = eyyyy + "-" + emm + "-" + edd + "T" + hours + ":" + emin;
    }

    let todateEnd = eyyyy + "-" + emm + "-" + edd + "T";
    // 2022-06-06T08:57:27.000Z

    if (typeRecurring === "oneTime") {
      if (addclick === "addData" || addclick === "edit") {
        if (props.chargetrip === "Charging Schedule") {
          let sheduledata = {
            setpoints: [
              {
                power: percentSteps,
                effectivePeriod: {
                  from: fromdate,
                  to: todate,
                },
              },
            ],
          };
          let addSheduleJson = JSON.stringify(sheduledata);
          props.scheduleddata(addSheduleJson, addclick);
        } else {
          //add trip schedule one time
          let startTime;
          let endTime;
          for (let i = 0; i < minsArray?.length; i++) {
            if (minsArray[i].min === sours) {
              if (unitsSystem === "metric") {
                startTime = sours + ":" + smin;
              } else {
                if (sAmPm === "pm") {
                  let hours = i == "12" ? i : 12 + i;
                  startTime = hours.toString() + ":" + smin;
                } else {
                  let hours = sours == "12" ? "00" : sours;
                  startTime = hours + ":" + smin;
                }
              }
            }
            if (minsArray[i].min === ehours) {
              if (unitsSystem === "metric") {
                endTime = ehours + ":" + emin;
              } else {
                if (eAmPm === "pm") {
                  let ehour = i == "12" ? i : 12 + i;
                  endTime = ehour.toString() + ":" + emin;
                } else {
                  let hours = ehours == "12" ? "00" : ehours;
                  endTime = hours + ":" + emin;
                }
              }
            }
          }
          let sheduledata = {
            name: "Trip Schedule",
            soc: percentSteps,
            period: {
              from: fsromdate + startTime,
              to: todateEnd + endTime,
            },
          };
          // debugger

          //     const tz = "America/New_York"; // GMT-0500
          //    let date = moment(fsromdate + startTime).tz(tz, true).format('YYYY-MM-DDThh:mm');

          //  let date1 =  date.designator("Z")
          //let date=    new Date(fsromdate + startTime)
          // console.log('converted',date + ' date1'+date1, 'normaldate',fsromdate + startTime)
          let addSheduleJson = JSON.stringify(sheduledata);
          console.log("x", addSheduleJson);
          props.scheduleddata(addSheduleJson, addclick);
        }
      }
    } else {
      if (addclick === "addData" || addclick === "edit") {
        let priviousto = "";
        let nextfrom = "";
        let startTime;
        let endTime;
        for (let i = 0; i < minsArray?.length; i++) {
          if (minsArray[i].min === sours) {
            if (sAmPm === "pm") {
              let hours = i == "12" ? i : 12 + i;
              startTime = hours.toString() + ":" + smin + ":00";
              priviousto = hours + ":" + smin + ":00";
            } else {
              let hours = sours == "12" ? "00" : sours;
              priviousto = hours + ":" + smin + ":00";
              startTime = hours + ":" + smin + ":00";
            }
          }
          if (minsArray[i].min === ehours) {
            if (eAmPm === "pm") {
              let ehour = i == "12" ? i : 12 + i;
              endTime = ehour.toString() + ":" + emin + ":00";
              nextfrom = ehour + ":" + emin + ":00";
            } else {
              let hours = ehours == "12" ? "00" : ehours;
              nextfrom = hours + ":" + emin + ":00";
              endTime = hours + ":" + emin + ":00";
            }
          }
        }

        if (props.chargetrip === "Charging Schedule") {
          let weekDays = [
            {
              power: 0,
              dayOfWeek: "SUNDAY",
              timespan: {
                from: "00:00:00",
                to: selectSun === true ? priviousto : "01:00:00",
              },
              forcedCharge: false,
            },
            {
              power: selectSun === true ? 60 : 0,
              dayOfWeek: "SUNDAY",
              timespan: {
                from: selectSun === true ? startTime : "01:00:00",
                to: selectSun === true ? endTime : "02:00:00",
              },
              forcedCharge: false,
            },
            {
              power: 0,
              dayOfWeek: "SUNDAY",
              timespan: {
                from: selectSun === true ? nextfrom : "02:00:00",
                to: null,
              },
              forcedCharge: false,
            },
            {
              power: 0,
              dayOfWeek: "MONDAY",
              timespan: {
                from: "00:00:00",
                to: selectMon === true ? priviousto : "01:00:00",
              },
              forcedCharge: false,
            },
            {
              power: selectMon === true ? 60 : 0,
              dayOfWeek: "MONDAY",
              timespan: {
                from: selectMon === true ? startTime : "01:00:00",
                to: selectMon === true ? endTime : "02:00:00",
              },
              forcedCharge: false,
            },
            {
              power: 0,
              dayOfWeek: "MONDAY",
              timespan: {
                from: selectMon === true ? nextfrom : "02:00:00",
                to: null,
              },
              forcedCharge: false,
            },
            {
              power: 0,
              dayOfWeek: "TUESDAY",
              timespan: {
                from: "00:00:00",
                to: selectTue === true ? priviousto : "01:00:00",
              },
              forcedCharge: false,
            },
            {
              power: selectTue === true ? 60 : 0,
              dayOfWeek: "TUESDAY",
              timespan: {
                from: selectTue === true ? startTime : "01:00:00",
                to: selectTue === true ? endTime : "02:00:00",
              },
              forcedCharge: false,
            },
            {
              power: 0,
              dayOfWeek: "TUESDAY",
              timespan: {
                from: selectTue === true ? nextfrom : "02:00:00",
                to: null,
              },
              forcedCharge: false,
            },
            {
              power: 0,
              dayOfWeek: "WEDNESDAY",
              timespan: {
                from: "00:00:00",
                to: selectWed === true ? priviousto : "01:00:00",
              },
              forcedCharge: false,
            },
            {
              power: selectWed === true ? 60 : 0,
              dayOfWeek: "WEDNESDAY",
              timespan: {
                from: selectWed === true ? startTime : "01:00:00",
                to: selectWed === true ? endTime : "02:00:00",
              },
              forcedCharge: false,
            },
            {
              power: 0,
              dayOfWeek: "WEDNESDAY",
              timespan: {
                from: selectWed === true ? nextfrom : "02:00:00",
                to: null,
              },
              forcedCharge: false,
            },
            {
              power: 0,
              dayOfWeek: "THURSDAY",
              timespan: {
                from: "00:00:00",
                to: selectThu === true ? priviousto : "01:00:00",
              },
              forcedCharge: false,
            },
            {
              power: selectThu === true ? 60 : 0,
              dayOfWeek: "THURSDAY",
              timespan: {
                from: selectThu === true ? startTime : "01:00:00",
                to: selectThu === true ? endTime : "02:00:00",
              },
              forcedCharge: false,
            },
            {
              power: 0,
              dayOfWeek: "THURSDAY",
              timespan: {
                from: selectThu === true ? nextfrom : "02:00:00",
                to: null,
              },
              forcedCharge: false,
            },
            {
              power: 0,
              dayOfWeek: "FRIDAY",
              timespan: {
                from: "00:00:00",
                to: selectFri === true ? priviousto : "01:00:00",
              },
              forcedCharge: false,
            },
            {
              power: selectFri === true ? 60 : 0,
              dayOfWeek: "FRIDAY",
              timespan: {
                from: selectFri === true ? startTime : "01:00:00",
                to: selectFri === true ? endTime : "02:00:00",
              },
              forcedCharge: false,
            },
            {
              power: 0,
              dayOfWeek: "FRIDAY",
              timespan: {
                from: selectFri === true ? nextfrom : "02:00:00",
                to: null,
              },
              forcedCharge: false,
            },
            {
              power: 0,
              dayOfWeek: "SATURDAY",
              timespan: {
                from: "00:00:00",
                to: selectSat === true ? priviousto : "01:00:00",
              },
              forcedCharge: false,
            },
            {
              power: selectSat === true ? 60 : 0,
              dayOfWeek: "SATURDAY",
              timespan: {
                from: selectSat === true ? startTime : "01:00:00",
                to: selectSat === true ? endTime : "02:00:00",
              },
              forcedCharge: false,
            },
            {
              power: 0,
              dayOfWeek: "SATURDAY",
              timespan: {
                from: selectSat === true ? nextfrom : "02:00:00",
                to: null,
              },
              forcedCharge: false,
            },
          ];

          // var weekdayfilter = weekDays.filter((el) => {
          //     return el.dayOfWeek != "";
          // })
          let sheduledata = {
            setpoints: weekDays,
            timezone: "America/New_York",
            effectivePeriod: {
              from: fromdate,
              to: todate,
            },
          };
          let addSheduleJson = JSON.stringify(sheduledata);
          props.scheduleddata(addSheduleJson, addclick, typeRecurring);
        } else {
          //add recurring trip schedule
          let weekDays = [
            selectSun === true ? "SUNDAY" : "",
            selectMon === true ? "MONDAY" : "",
            selectTue === true ? "TUESDAY" : "",
            selectWed === true ? "WEDNESDAY" : "",
            selectThu === true ? "THURSDAY" : "",
            selectFri === true ? "FRIDAY" : "",
            selectSat === true ? "SATURDAY" : "",
          ];
          var filterDays = weekDays.filter((el) => {
            return el != "";
          });
          let startTime;
          let endTime;
          for (let i = 0; i < minsArray?.length; i++) {
            if (minsArray[i].min === sours) {
              if (unitsSystem === "metric") {
                startTime = sours + ":" + smin + ":00";
              } else {
                if (sAmPm === "pm") {
                  let hours = i == "12" ? i : 12 + i;
                  // let hours = i === 11 ? 12 + i : 12 + i + 1;
                  startTime = hours.toString() + ":" + smin + ":00";
                } else {
                  let hours = sours == "12" ? "00" : sours;
                  startTime = hours + ":" + smin + ":00";
                }
              }
            }
            if (minsArray[i].min === ehours) {
              if (unitsSystem === "metric") {
                endTime = ehours + ":" + emin + ":00";
              } else {
                if (eAmPm === "pm") {
                  let ehour = i == "12" ? i : 12 + i;
                  // let ehour = i === 11 ? 12 + i : 12 + i + 1;
                  endTime = ehour.toString() + ":" + emin + ":00";
                } else {
                  let hours = ehours == "12" ? "00" : ehours;
                  endTime = hours + ":" + emin + ":00";
                }
              }
            }
          }
          let sheduledata = {
            name: typeRecurring,
            period: {
              from: startTime,
              to: endTime,
            },
            soc: percentSteps,
            daysOfWeek: filterDays,
            recurrence: {
              from: fromdate,
              to: todate,
            },
          };
          let addSheduleJson = JSON.stringify(sheduledata);
          props.scheduleddata(addSheduleJson, addclick, typeRecurring);
        }
      } else {
        //edit block
        if (props.chargetrip === "Charging Schedule") {
          let priviousto = "";
          let nextfrom = "";
          let startTime;
          let endTime;
          for (let i = 0; i < minsArray?.length; i++) {
            if (minsArray[i].min === sours) {
              if (sAmPm === "pm") {
                let hours = i === 11 ? 12 + i : 12 + i + 1;
                startTime = hours.toString() + ":" + smin + ":00";
                priviousto = hours + ":" + smin + ":00";
              } else {
                priviousto = sours + ":" + smin + ":00";
                startTime = sours + ":" + smin + ":00";
              }
            }
            if (minsArray[i].min === ehours) {
              if (eAmPm === "pm") {
                let ehour = i === 11 ? 12 + i : 12 + i + 1;
                endTime = ehour.toString() + ":" + emin + ":00";
                nextfrom = ehour + ":" + emin + ":00";
              } else {
                nextfrom = ehours + ":" + emin + ":00";
                endTime = ehours + ":" + emin + ":00";
              }
            }
          }
          let weekDays = [
            {
              power: 0,
              dayOfWeek: "SUNDAY",
              timespan: {
                from: "00:00:00",
                to: selectSun === true ? priviousto : "01:00:00",
              },
              forcedCharge: false,
            },
            {
              power: selectSun === true ? 60 : 0,
              dayOfWeek: "SUNDAY",
              timespan: {
                from: selectSun === true ? startTime : "01:00:00",
                to: selectSun === true ? endTime : "02:00:00",
              },
              forcedCharge: false,
            },
            {
              power: 0,
              dayOfWeek: "SUNDAY",
              timespan: {
                from: selectSun === true ? nextfrom : "02:00:00",
                to: null,
              },
              forcedCharge: false,
            },
            {
              power: 0,
              dayOfWeek: "MONDAY",
              timespan: {
                from: "00:00:00",
                to: selectMon === true ? priviousto : "01:00:00",
              },
              forcedCharge: false,
            },
            {
              power: selectMon === true ? 60 : 0,
              dayOfWeek: "MONDAY",
              timespan: {
                from: selectMon === true ? startTime : "01:00:00",
                to: selectMon === true ? endTime : "02:00:00",
              },
              forcedCharge: false,
            },
            {
              power: 0,
              dayOfWeek: "MONDAY",
              timespan: {
                from: selectMon === true ? nextfrom : "02:00:00",
                to: null,
              },
              forcedCharge: false,
            },
            {
              power: 0,
              dayOfWeek: "TUESDAY",
              timespan: {
                from: "00:00:00",
                to: selectTue === true ? priviousto : "01:00:00",
              },
              forcedCharge: false,
            },
            {
              power: selectTue === true ? 60 : 0,
              dayOfWeek: "TUESDAY",
              timespan: {
                from: selectTue === true ? startTime : "01:00:00",
                to: selectTue === true ? endTime : "02:00:00",
              },
              forcedCharge: false,
            },
            {
              power: 0,
              dayOfWeek: "TUESDAY",
              timespan: {
                from: selectTue === true ? nextfrom : "02:00:00",
                to: null,
              },
              forcedCharge: false,
            },
            {
              power: 0,
              dayOfWeek: "WEDNESDAY",
              timespan: {
                from: "00:00:00",
                to: selectWed === true ? priviousto : "01:00:00",
              },
              forcedCharge: false,
            },
            {
              power: selectWed === true ? 60 : 0,
              dayOfWeek: "WEDNESDAY",
              timespan: {
                from: selectWed === true ? startTime : "01:00:00",
                to: selectWed === true ? endTime : "02:00:00",
              },
              forcedCharge: false,
            },
            {
              power: 0,
              dayOfWeek: "WEDNESDAY",
              timespan: {
                from: selectWed === true ? nextfrom : "02:00:00",
                to: null,
              },
              forcedCharge: false,
            },
            {
              power: 0,
              dayOfWeek: "THURSDAY",
              timespan: {
                from: "00:00:00",
                to: selectThu === true ? priviousto : "01:00:00",
              },
              forcedCharge: false,
            },
            {
              power: selectThu === true ? 60 : 0,
              dayOfWeek: "THURSDAY",
              timespan: {
                from: selectThu === true ? startTime : "01:00:00",
                to: selectThu === true ? endTime : "02:00:00",
              },
              forcedCharge: false,
            },
            {
              power: 0,
              dayOfWeek: "THURSDAY",
              timespan: {
                from: selectThu === true ? nextfrom : "02:00:00",
                to: null,
              },
              forcedCharge: false,
            },
            {
              power: 0,
              dayOfWeek: "FRIDAY",
              timespan: {
                from: "00:00:00",
                to: selectFri === true ? priviousto : "01:00:00",
              },
              forcedCharge: false,
            },
            {
              power: selectFri === true ? 60 : 0,
              dayOfWeek: "FRIDAY",
              timespan: {
                from: selectFri === true ? startTime : "01:00:00",
                to: selectFri === true ? endTime : "02:00:00",
              },
              forcedCharge: false,
            },
            {
              power: 0,
              dayOfWeek: "FRIDAY",
              timespan: {
                from: selectFri === true ? nextfrom : "02:00:00",
                to: null,
              },
              forcedCharge: false,
            },
            {
              power: 0,
              dayOfWeek: "SATURDAY",
              timespan: {
                from: "00:00:00",
                to: selectSat === true ? priviousto : "01:00:00",
              },
              forcedCharge: false,
            },
            {
              power: selectSat === true ? 60 : 0,
              dayOfWeek: "SATURDAY",
              timespan: {
                from: selectSat === true ? startTime : "01:00:00",
                to: selectSat === true ? endTime : "02:00:00",
              },
              forcedCharge: false,
            },
            {
              power: 0,
              dayOfWeek: "SATURDAY",
              timespan: {
                from: selectSat === true ? nextfrom : "02:00:00",
                to: null,
              },
              forcedCharge: false,
            },
          ];

          let sheduledata = {
            setpoints: weekDays,
            timezone: "America/New_York",
            effectivePeriod: {
              from: fromdate,
              to: todate,
            },
          };
          // let addSheduleJson = JSON.stringify(sheduledata)

          props.scheduleddata(sheduledata, addclick, typeRecurring);
        } else {
          //edit trip block
        }
      }
    }

    // reset();
  };

  const editShedule = () => {
    if (addclick !== "addData") {
      // debugger
      if (props.data[1] > 1000) {
        if (props.data[9] === "TripOneTime") {
          let sdate = new Date(props.data[8]);
          let shours = String(sdate.getHours());
          let sMin = String(sdate.getMinutes());
          if (parseInt(shours) >= 12) {
            if (unitsSystem === "metric") {
              setValue("startHours", shours);
              let smins = parseInt(sMin) < 10 ? "0" + sMin : sMin;
              setValue("startMin", smins);
            } else {
              let shars =
                shours == 12 ? parseInt(shours) : parseInt(shours) - 12;
              let hars =
                shars < 10 ? "0" + shars?.toString() : shars?.toString();
              setValue("startHours", hars);
              setValue("sAmPm", "pm");
              let smins = parseInt(sMin) < 10 ? "0" + sMin : sMin;
              setValue("startMin", smins);
            }
          } else {
            let hars =
              parseInt(shours) === 0 && unitsSystem !== "metric"
                ? 12
                : parseInt(shours) < 10
                ? "0" + shours
                : shours;
            setValue("startHours", hars);
            let smins = parseInt(sMin) < 10 ? "0" + sMin : sMin;
            setValue("startMin", smins);
          }
          console.log("sdate: ", sdate);
          // console.log('startDate: ', startDate)
          setStartDate(sdate);
          setValue("startDate", sdate);

          // setValue('startMin', sMin)
          let enddate = new Date(props.data[7]);
          let eHours = String(enddate.getHours());
          let eMin = String(enddate.getMinutes());

          if (parseInt(eHours) >= 12) {
            if (unitsSystem === "metric") {
              setValue("endHours", eHours);
              let emins = parseInt(eMin) < 10 ? "0" + eMin : eMin;
              setValue("endMin", emins);
            } else {
              let shars =
                eHours == 12 ? parseInt(eHours) : parseInt(eHours) - 12;
              let hars =
                shars < 10 ? "0" + shars?.toString() : shars?.toString();
              setValue("endHours", hars);
              setValue("eAmPm", "pm");
              let smins = parseInt(eMin) < 10 ? "0" + eMin : eMin;
              setValue("endMin", smins);
            }
          } else {
            let ehars =
              parseInt(eHours) === 0 && unitsSystem !== "metric"
                ? 12
                : parseInt(eHours) < 10
                ? "0" + eHours
                : eHours;
            setValue("endHours", ehars);
            let emins = parseInt(eMin) < 10 ? "0" + eMin : eMin;
            setValue("endMin", emins);
          }
          setEndDate(enddate);
          setValue("endDate", enddate);
        } else {
          let sdate = new Date(props.data[1]);
          let shours = String(sdate.getHours());
          let sMin = String(sdate.getMinutes());
          if (parseInt(shours) >= 12) {
            if (unitsSystem === "metric") {
              setValue("startHours", shours);
              let smins = parseInt(sMin) < 10 ? "0" + sMin : sMin;
              setValue("startMin", smins);
            } else {
              let shars =
                shours == 12 ? parseInt(shours) : parseInt(shours) - 12;
              let hars =
                shars < 10 ? "0" + shars?.toString() : shars?.toString();
              setValue("startHours", hars);
              setValue("sAmPm", "pm");
              let smins = parseInt(sMin) < 10 ? "0" + sMin : sMin;
              setValue("startMin", smins);
            }
          } else {
            let hars =
              parseInt(shours) === 0 && unitsSystem !== "metric"
                ? 12
                : parseInt(shours) < 10
                ? "0" + shours
                : shours;
            setValue("startHours", hars);
            let smins = parseInt(sMin) < 10 ? "0" + sMin : sMin;
            setValue("startMin", smins);
          }
          console.log("sdate: ", sdate);
          // console.log('startDate: ', startDate)
          setStartDate(sdate);
          setValue("startDate", sdate);

          // setValue('startMin', sMin)
          let enddate = new Date(props.data[2]);
          let eHours = String(enddate.getHours());
          let eMin = String(enddate.getMinutes());

          if (parseInt(eHours) >= 12) {
            if (unitsSystem === "metric") {
              setValue("endHours", eHours);
              let emins = parseInt(eMin) < 10 ? "0" + eMin : eMin;
              setValue("endMin", emins);
            } else {
              let shars =
                eHours == 12 ? parseInt(eHours) : parseInt(eHours) - 12;
              let hars =
                shars < 10 ? "0" + shars?.toString() : shars?.toString();
              setValue("endHours", hars);
              setValue("eAmPm", "pm");
              let smins = parseInt(eMin) < 10 ? "0" + eMin : eMin;
              setValue("endMin", smins);
            }
          } else {
            let ehars =
              parseInt(eHours) === 0 && unitsSystem !== "metric"
                ? 12
                : parseInt(eHours) < 10
                ? "0" + eHours
                : eHours;
            setValue("endHours", ehars);
            let emins = parseInt(eMin) < 10 ? "0" + eMin : eMin;
            setValue("endMin", emins);
          }
          console.log("enddateenddate", enddate);
          setEndDate(enddate);
          setValue("endDate", enddate);
        }
        if (props.chargetrip === "Charging Schedule") {
          setoneTimeState("Recurring");
          let recID = props?.data[4];
          localStorage.setItem("recurringID", recID);

          let weekDays = props?.data[5];
          for (let i = 0; i < weekDays?.length; i++) {
            if (weekDays[i]?.power > 0) {
              if (weekDays[i]?.dayOfWeek === "MONDAY") {
                setSelectMon(true);
              }
              if (weekDays[i].dayOfWeek === "TUESDAY") {
                setselectTue(true);
              }
              if (weekDays[i].dayOfWeek === "WEDNESDAY") {
                setselectWed(true);
              }
              if (weekDays[i].dayOfWeek === "THURSDAY") {
                setselectThu(true);
              }
              if (weekDays[i].dayOfWeek === "FRIDAY") {
                setselectFri(true);
              }
              if (weekDays[i].dayOfWeek === "SATURDAY") {
                setselectSat(true);
              }
              if (weekDays[i].dayOfWeek === "SUNDAY") {
                setSelectSun(true);
              }
            }
          }
        } else {
          if (props?.data[3] !== "") {
            let val = props?.data[3];
            milege = map1?.get(val);
            setProgressValue(val);
            setValue("sliderVal", val);
          }
          let type = "Recurring";
          if (props?.data[4] === "Recurring") {
            setoneTimeState(type);
            let date = props?.data[6];
            // let date = startDate.setDate(startDate.getDate() + 7);
            setEndDate(new Date(date));
            setValue("endDate", new Date(date));
          }
          if (props?.data[5] !== "" || props.data[5] !== undefined) {
            recID = props?.data[5]?.id;
            localStorage.setItem("recurringID", recID);

            if (props?.data[4] === "Recurring") {
              let weekDays = props?.data[5];
              for (let i = 0; i < weekDays?.daysOfWeek?.length; i++) {
                if (weekDays?.daysOfWeek[i] === "MONDAY") {
                  setSelectMon(true);
                }
                if (weekDays?.daysOfWeek[i] === "TUESDAY") {
                  setselectTue(true);
                }
                if (weekDays?.daysOfWeek[i] === "WEDNESDAY") {
                  setselectWed(true);
                }
                if (weekDays?.daysOfWeek[i] === "THURSDAY") {
                  setselectThu(true);
                }
                if (weekDays?.daysOfWeek[i] === "FRIDAY") {
                  setselectFri(true);
                }
                if (weekDays?.daysOfWeek[i] === "SATURDAY") {
                  setselectSat(true);
                }
                if (weekDays?.daysOfWeek[i] === "SUNDAY") {
                  setSelectSun(true);
                }
              }
            }
          }
        }
      }
    }
  };
  //  const targetSlider=()=>{
  if (percentage > 0 && percentage < 28) {
    if (percentage === 1) {
      percentSteps = percentage;
      milege = map1?.get(percentSteps);
    } else {
      percentSteps = 1 + percentage;
      milege = map1?.get(percentSteps);
    }
  } else if (percentage >= 28 && percentage < 53) {
    percentSteps = 1 + percentage;
    milege = map1?.get(percentSteps);
  } else {
    percentSteps = 0 + percentage;
    milege = map1?.get(percentSteps);
  }
  // }

  const sliderProps = {
    min: 0,
    max: 100,
    step: percentage === 0 ? 1 : percentage <= 53 ? 2 : 1,
  };

  useEffect(() => {
    editShedule();
    recurringCharger();
  }, []);

  function handleChange(evt) {
    setoneTimeState(evt.target.value);
    if (evt.target.value === "Recurring") {
      if (addclick === "addData") {
        let sdate = new Date();
        let date = sdate.setDate(sdate.getDate() + 7);
        setEndDate(new Date(date));
      } else {
        let date = startDate.setDate(startDate.getDate() + 7);
        setEndDate(new Date(date));
      }
    } else {
      let date = startDate;
      setEndDate(new Date(date));
    }
  }
  const recuringData = (e) => {
    if (selectSun === true) {
    }
  };
  const closeP = () => {
    props.closePopu(false);
  };

  const editTripSchedule = (e) => {
    var id = localStorage.getItem("recurringID");
    props.deleteCall(id, typeRecurring);
    handleSubmit(onSubmit)();
  };

  const deleteSchedule = (e) => {
    var id = localStorage.getItem("recurringID");
    props.deleteCall(id, typeRecurring);
    props.closePopu(false);
  };
  $(
    ".react-date-picker__inputGroup__year,.react-date-picker__inputGroup__month,.react-date-picker__inputGroup__day"
  ).on("keydown", function (event) {
    var key = event.keyCode || event.charCode;
    if (key == 8 || key == 46) return false;
  });

  const limitKeypress = (event) => {
    event.preventDefault();
    return false;
  };

  return (
    <div className={cn(styles.addPopup)}>
      <div
        className={
          addclick !== "addData" && props?.chargetrip === "Trip Schedule"
            ? cn(styles.viewCss)
            : props?.chargetrip === "Charging Schedule"
            ? cn(styles.addInnerPopupCharge)
            : cn(styles.addInnerPopup)
        }
      >
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className={cn(styles.popupHeader)}>
            <img
              className={cn(styles.popup_CloseInner)}
              src={require("assets/close.png").default}
              alt="Rectangle 36"
              onClick={() => closeP()}
            />
            <h1 className={cn(styles.popupTitle)}>
              {addclick === "addData"
                ? "Add"
                : props.chargetrip === "Trip Schedule" &&
                  disableEditTripSchedule
                ? "View"
                : "Edit"}
              {props.chargetrip === "Charging Schedule"
                ? " Charging "
                : " Trip "}
              Schedule
            </h1>
          </div>

          <div className={styles.radioBox} />
          <div className={cn(styles.flexcontainertop)}>
            <div
              className={
                addclick !== "addData" && props?.chargetrip === "Trip Schedule"
                  ? cn(styles.abcd)
                  : cn(styles.radioCon)
              }
            >
              <div
                className={
                  props?.chargetrip === "Trip Schedule"
                    ? cn(styles.radiobCon, styles.mt20)
                    : cn(styles.radiobCon_Cschedule, styles.mt20)
                }
              >
                {addclick !== "addData" &&
                props?.chargetrip === "Trip Schedule" ? (
                  <div
                    className={
                      addclick !== "addData" &&
                      props?.chargetrip === "Trip Schedule"
                        ? cn(
                            styles.tripRadioContainerView,
                            styles.radioBoxlabel
                          )
                        : cn(styles.tripRadioContainer, styles.radioBoxlabel)
                    }
                  />
                ) : (
                  <label
                    className={
                      props.chargetrip === "Charging Schedule"
                        ? cn(styles.displayhidden)
                        : addclick !== "addData" &&
                          props?.chargetrip === "Trip Schedule"
                        ? cn(styles.tripRadioContainerView)
                        : cn(styles.tripRadioContainer, styles.radioBoxlabel)
                    }
                  >
                    One-time
                    <input
                      type="radio"
                      name="radio"
                      checked={onetimestate === "oneTime" ? true : false}
                      onChange={handleChange}
                      value="oneTime"
                    />
                    <span className={cn(styles.checkmarkTrip)}></span>
                  </label>
                )}
              </div>
              <div
                className={cn(
                  addclick === "addData" ? styles.radiobCon : styles.radiobCon
                )}
              >
                {addclick !== "addData" &&
                props?.chargetrip === "Trip Schedule" ? (
                  <div
                    className={
                      addclick !== "addData" &&
                      props?.chargetrip === "Trip Schedule"
                        ? cn(styles.tripRadioContainerView)
                        : cn(styles.tripRadioContainer, styles.radioBoxlabel)
                    }
                  >
                    {/* <input {...register('recurring', { required: false })} type="radio" checked={onetimestate === 'Recurring' ? true : false} onChange={handleChange} name="radio" value="Recurring" disabled={addclick === 'addData' && onetimestate === 'oneTime' ? false : addclick !== 'addData' && onetimestate === 'oneTime' ? true : false} />
                                    <span className={cn(styles.checkmarkTrip)}></span> */}
                  </div>
                ) : (
                  <label
                    className={
                      addclick !== "addData" &&
                      props?.chargetrip === "Trip Schedule"
                        ? cn(styles.tripRadioContainerView)
                        : props?.chargetrip !== "Trip Schedule"
                        ? cn(
                            styles.tripRadioContainerCharger,
                            styles.radioBoxlabel
                          )
                        : cn(styles.tripRadioContainer, styles.radioBoxlabel)
                    }
                  >
                    Recurring
                    <input
                      {...register("recurring", { required: false })}
                      type="radio"
                      checked={onetimestate === "Recurring" ? true : false}
                      onChange={handleChange}
                      name="radio"
                      value="Recurring"
                    />
                    <span className={cn(styles.checkmarkTrip)}></span>
                  </label>
                )}
              </div>
            </div>

            <div
              className={cn(
                onetimestate === "Recurring"
                  ? styles.divdate
                  : styles.displayNone
              )}
            >
              <h2>Repeat every*</h2>
              <div>
                {addclick !== "addData" &&
                props?.chargetrip === "Trip Schedule" ? (
                  <>
                    <div
                      onClick={(e) => {
                        if (!disableEditTripSchedule) {
                          setSelectSun(!selectSun);
                          recuringData("Sunday");
                        }
                      }}
                      className={
                        selectSun === true
                          ? cn(styles.daysBlock, styles.activedays)
                          : cn(styles.daysBlock)
                      }
                    >
                      Su
                    </div>
                    <div
                      onClick={(e) => {
                        if (!disableEditTripSchedule) {
                          setSelectMon(!selectMon);
                          recuringData("Monday");
                        }
                      }}
                      className={
                        selectMon === true
                          ? cn(styles.daysBlock, styles.activedays)
                          : cn(styles.daysBlock)
                      }
                    >
                      M
                    </div>
                    <div
                      onClick={(e) => {
                        if (!disableEditTripSchedule) {
                          setselectTue(!selectTue);
                          recuringData("Tuesday");
                        }
                      }}
                      className={
                        selectTue === true
                          ? cn(styles.daysBlock, styles.activedays)
                          : cn(styles.daysBlock)
                      }
                    >
                      T
                    </div>
                    <div
                      onClick={(e) => {
                        if (!disableEditTripSchedule) {
                          setselectWed(!selectWed);
                          recuringData("Wednesday");
                        }
                      }}
                      className={
                        selectWed === true
                          ? cn(styles.daysBlock, styles.activedays)
                          : cn(styles.daysBlock)
                      }
                    >
                      W
                    </div>
                    <div
                      onClick={(e) => {
                        if (!disableEditTripSchedule) {
                          setselectThu(!selectThu);
                          recuringData("Thursday");
                        }
                      }}
                      className={
                        selectThu === true
                          ? cn(styles.daysBlock, styles.activedays)
                          : cn(styles.daysBlock)
                      }
                    >
                      Th
                    </div>
                    <div
                      onClick={(e) => {
                        if (!disableEditTripSchedule) {
                          setselectFri(!selectFri);
                          recuringData("Friday");
                        }
                      }}
                      className={
                        selectFri === true
                          ? cn(styles.daysBlock, styles.activedays)
                          : cn(styles.daysBlock)
                      }
                    >
                      F
                    </div>
                    <div
                      onClick={(e) => {
                        if (!disableEditTripSchedule) {
                          setselectSat(!selectSat);
                          recuringData("Saturday");
                        }
                      }}
                      className={
                        selectSat === true
                          ? cn(styles.daysBlock, styles.activedays)
                          : cn(styles.daysBlock)
                      }
                    >
                      S
                    </div>
                  </>
                ) : (
                  <>
                    <div
                      onClick={(e) => (
                        setSelectSun(!selectSun), recuringData("Sunday")
                      )}
                      className={
                        selectSun === true
                          ? cn(styles.daysBlock, styles.activedays)
                          : cn(styles.daysBlock)
                      }
                    >
                      Su
                    </div>
                    <div
                      onClick={(e) => (
                        setSelectMon(!selectMon), recuringData("Monday")
                      )}
                      className={
                        selectMon === true
                          ? cn(styles.daysBlock, styles.activedays)
                          : cn(styles.daysBlock)
                      }
                    >
                      M
                    </div>
                    <div
                      onClick={(e) => (
                        setselectTue(!selectTue), recuringData("Tuesday")
                      )}
                      className={
                        selectTue === true
                          ? cn(styles.daysBlock, styles.activedays)
                          : cn(styles.daysBlock)
                      }
                    >
                      T
                    </div>
                    <div
                      onClick={(e) => (
                        setselectWed(!selectWed), recuringData("Wednesday")
                      )}
                      className={
                        selectWed === true
                          ? cn(styles.daysBlock, styles.activedays)
                          : cn(styles.daysBlock)
                      }
                    >
                      W
                    </div>
                    <div
                      onClick={(e) => (
                        setselectThu(!selectThu), recuringData("Thursday")
                      )}
                      className={
                        selectThu === true
                          ? cn(styles.daysBlock, styles.activedays)
                          : cn(styles.daysBlock)
                      }
                    >
                      Th
                    </div>
                    <div
                      onClick={(e) => (
                        setselectFri(!selectFri), recuringData("Friday")
                      )}
                      className={
                        selectFri === true
                          ? cn(styles.daysBlock, styles.activedays)
                          : cn(styles.daysBlock)
                      }
                    >
                      F
                    </div>
                    <div
                      onClick={(e) => (
                        setselectSat(!selectSat), recuringData("Saturday")
                      )}
                      className={
                        selectSat === true
                          ? cn(styles.daysBlock, styles.activedays)
                          : cn(styles.daysBlock)
                      }
                    >
                      S
                    </div>
                  </>
                )}
              </div>
              {recurringError && (
                <h2 className={cn(styles.error)}> {recurringError} </h2>
              )}
            </div>

            <div
              className={cn(
                onetimestate === "Recurring"
                  ? addclick !== "addData" &&
                    props?.chargetrip === "Trip Schedule"
                    ? cn(styles.tripRadioContainerView)
                    : styles.radioCon
                  : styles.displayNone
              )}
            />

            <div
              className={
                onetimestate === "oneTime"
                  ? addclick !== "addData" &&
                    props?.chargetrip === "Trip Schedule"
                    ? cn(styles.divdate, styles.viewWidth36)
                    : cn(styles.divdate, styles.width36)
                  : addclick !== "addData" &&
                    props?.chargetrip === "Trip Schedule"
                  ? cn(styles.divdate, styles.viewWidth36, styles.leftmarginR)
                  : cn(styles.divdate, styles.width36, styles.margintop30)
              }
            >
              <h2>
                {props.chargetrip === "Charging Schedule"
                  ? "Start Date*"
                  : addclick === "addData"
                  ? "Schedule Date"
                  : "Start Date"}
              </h2>

              <div className={cn(styles.datepiker, styles.datepiker1)}>
                <Controller
                  control={control}
                  name="startDate"
                  rules={{ required: true }}
                  render={({ field }) => (
                    <DatePicker
                      // onKeyPress={(e) => limitKeypress(e)}
                      // onChange={(date) => setStartDate(date)}
                      onChange={(date) => field.onChange(date)}
                      value={field.value}
                      // value={startDate}
                      format={
                        unitsSystem === "metric" ? "dd/MM/yyyy" : "MM/dd/yyyy"
                      }
                      disableCalendar={
                        addclick !== "addData" &&
                        props?.chargetrip === "Trip Schedule"
                          ? // ? true
                            disableEditTripSchedule
                          : false
                      }
                      minDate={addclick === "addData" ? moment().toDate() : ""}
                    />
                  )}
                />
                <div
                  style={{
                    position: "absolute",
                    right: "12px",
                    top: "7px",
                    zIndex: "0",
                  }}
                >
                  <img
                    src={require("assets/calendar.svg").default}
                    alt="calendar"
                  />
                </div>
              </div>
              {errors.startDate && (
                <h2 className={cn(styles.error)}> {scheduleDateError} </h2>
              )}

              {/* {startDateError !== "" && (
                <h2 className={cn(styles.error)}> {startDateError} </h2>
              )} */}
            </div>

            <div
              className={
                onetimestate === "oneTime"
                  ? addclick !== "addData" &&
                    props?.chargetrip === "Trip Schedule"
                    ? cn(styles.divdate, styles.viewWidth36)
                    : cn(styles.divdate, styles.width36)
                  : addclick !== "addData" &&
                    props?.chargetrip === "Trip Schedule"
                  ? cn(styles.divdate, styles.viewWidth36)
                  : cn(styles.divdate, styles.width36, styles.margintop30)
              }
            >
              <h2>
                {props.chargetrip === "Charging Schedule"
                  ? "End Date"
                  : addclick === "addData"
                  ? "End of Trip Date"
                  : "End Date"}
              </h2>
              <div className={cn(styles.datepiker, styles.datepiker1)}>
                <Controller
                  control={control}
                  name="endDate"
                  rules={{ required: true }}
                  render={({ field }) => (
                    <DatePicker
                      // onKeyPress={(e) => limitKeypress(e)}
                      // onChange={(date) => setEndDate(date)}
                      onChange={(date) => field.onChange(date)}
                      value={field.value}
                      // value={endDate}
                      format={
                        unitsSystem === "metric" ? "dd/MM/yyyy" : "MM/dd/yyyy"
                      }
                      disableCalendar={
                        addclick !== "addData" &&
                        props?.chargetrip === "Trip Schedule"
                          ? // ? true
                            disableEditTripSchedule
                          : false
                      }
                      minDate={addclick === "addData" ? moment().toDate() : ""}
                    />
                  )}
                />
                <div
                  style={{
                    position: "absolute",
                    right: "12px",
                    top: "7px",
                    zIndex: "0",
                  }}
                >
                  <img
                    src={require("assets/calendar.svg").default}
                    alt="calendar"
                  />
                </div>
              </div>
              {errors.endDate && (
                <h2 className={cn(styles.error)}> {endOfTripError} </h2>
              )}
            </div>
          </div>
          {endDateError !== "" && (
            <h2 className={cn(styles.error, styles.textCenterAlign)}>
              {endDateError}
            </h2>
          )}

          <div className={cn(styles.flexcontainer)}>
            <div
              className={
                addclick !== "addData" && props?.chargetrip === "Trip Schedule"
                  ? cn(styles.tripRadioContainerView)
                  : cn(styles.block1)
              }
            ></div>
            <div className={cn(styles.block2)}>
              <h2>
                {props.chargetrip === "Charging Schedule"
                  ? "Start Time"
                  : addclick === "addData"
                  ? "Departure Time"
                  : "Departure Time"}
              </h2>
              {addclick !== "addData" &&
              props?.chargetrip === "Trip Schedule" ? (
                <div
                  className={cn(
                    styles.time,
                    unitsSystem === "metric" && styles.width50
                  )}
                >
                  <select
                    {...register("startHours", { required: true })}
                    className={cn(styles.selectPiker, styles.dropdown)}
                    // disabled="true"
                    disabled={disableEditTripSchedule}
                  >
                    {unitsSystem === "metric"
                      ? minsArray
                          ?.slice(0, 24)
                          .map((item) => (
                            <option value={item.value}>{item.min}</option>
                          ))
                      : minsArray
                          ?.slice(1, 13)
                          .map((item) => (
                            <option value={item.value}>{item.min}</option>
                          ))}
                  </select>
                </div>
              ) : (
                <div
                  className={cn(
                    styles.time,
                    unitsSystem === "metric" && styles.width50
                  )}
                >
                  {addclick !== "addData" &&
                  props?.chargetrip === "Trip Schedule" ? (
                    <select
                      {...register("startHours", { required: true })}
                      className={cn(styles.selectPiker, styles.dropdown)}
                      // disabled="true"
                      disabled={disableEditTripSchedule}
                    >
                      {unitsSystem === "metric"
                        ? minsArray?.slice(0, 24).map((item, pos) => (
                            <option key={pos} value={item.value}>
                              {item.min}
                            </option>
                          ))
                        : minsArray?.slice(1, 13).map((item, pos) => (
                            <option key={pos} value={item.value}>
                              {item.min}
                            </option>
                          ))}
                    </select>
                  ) : (
                    <select
                      {...register("startHours", { required: true })}
                      className={cn(styles.selectPiker, styles.dropdown)}
                    >
                      <option hidden></option>
                      {unitsSystem === "metric"
                        ? minsArray?.slice(0, 24).map((item, pos) => (
                            <option key={pos} value={item.value}>
                              {item.min}
                            </option>
                          ))
                        : minsArray?.slice(1, 13).map((item, pos) => (
                            <option key={pos} value={item.value}>
                              {item.min}
                            </option>
                          ))}
                    </select>
                  )}
                </div>
              )}
              <div
                className={cn(
                  styles.time,
                  unitsSystem === "metric" && styles.width50
                )}
              >
                {addclick !== "addData" &&
                props?.chargetrip === "Trip Schedule" ? (
                  <select
                    {...register("startMin", { required: false })}
                    className={cn(styles.selectPiker, styles.dropdown)}
                    // disabled="true"
                    disabled={disableEditTripSchedule}
                  >
                    {minsArray.map((item, pos) => (
                      <option key={pos} value={item.min}>
                        {item.min}
                      </option>
                    ))}
                  </select>
                ) : (
                  <select
                    {...register("startMin", { required: true })}
                    className={cn(styles.selectPiker, styles.dropdown)}
                  >
                    <option hidden></option>
                    {minsArray.map((item, pos) => (
                      <option key={pos} value={item.min}>
                        {item.min}
                      </option>
                    ))}
                  </select>
                )}
              </div>

              <div className={cn(styles.time)}>
                {addclick !== "addData" &&
                props?.chargetrip === "Trip Schedule" ? (
                  unitsSystem === "metric" ? (
                    ""
                  ) : (
                    <select
                      {...register("sAmPm", { required: false })}
                      className={cn(styles.selectPiker, styles.dropdown)}
                      // disabled="true"
                      disabled={disableEditTripSchedule}
                    >
                      {/* {unitsSystem === 'metric' ? '' : */}
                      <>
                        <option value="am">AM</option>
                        <option value="pm">PM</option>
                      </>
                      {/* } */}
                    </select>
                  )
                ) : unitsSystem === "metric" ? (
                  ""
                ) : (
                  <select
                    {...register("sAmPm", { required: true })}
                    className={cn(styles.selectPiker, styles.dropdown)}
                  >
                    <option hidden></option>
                    {/* {unitsSystem === 'metric' ? '' : */}
                    <>
                      <option value="am">AM</option>
                      <option value="pm">PM</option>
                    </>
                    {/* } */}
                  </select>
                )}
              </div>
              {(errors.startHours || errors.startMin || errors.sAmPm) && (
                <h2 className={cn(styles.error)}> {departureTimeRequired} </h2>
              )}
            </div>

            <div className={cn(styles.block2)}>
              <h2 style={{ position: "relative" }}>
                {" "}
                {props.chargetrip === "Charging Schedule"
                  ? "End Time"
                  : addclick === "addData"
                  ? "Arrival Time "
                  : "Arrival Time"}
              </h2>
              <div
                className={cn(
                  styles.time2,
                  unitsSystem === "metric" && styles.width50
                )}
              >
                {addclick !== "addData" &&
                props?.chargetrip === "Trip Schedule" ? (
                  <select
                    {...register("endHours", { required: false })}
                    className={cn(styles.selectPiker, styles.dropdown)}
                    disabled={disableEditTripSchedule}
                    // disabled="true"
                  >
                    {unitsSystem === "metric"
                      ? minsArray?.slice(0, 24)?.map((item, pos) => (
                          <option key={pos} value={item.value}>
                            {item.min}
                          </option>
                        ))
                      : minsArray
                          ?.slice(1, 13)
                          ?.map((item) => (
                            <option value={item.value}>{item.min}</option>
                          ))}
                  </select>
                ) : (
                  <select
                    {...register("endHours", { required: true })}
                    className={cn(styles.selectPiker, styles.dropdown)}
                  >
                    <option hidden></option>
                    {unitsSystem === "metric"
                      ? minsArray?.slice(0, 24)?.map((item, pos) => (
                          <option key={pos} value={item.value}>
                            {item.min}
                          </option>
                        ))
                      : minsArray.slice(1, 13).map((item, pos) => (
                          <option key={pos} value={item.value}>
                            {item.min}
                          </option>
                        ))}
                  </select>
                )}
              </div>
              <div
                className={cn(
                  styles.time,
                  unitsSystem === "metric" && styles.width50
                )}
              >
                {addclick !== "addData" &&
                props?.chargetrip === "Trip Schedule" ? (
                  <select
                    {...register("endMin", { required: false })}
                    className={cn(styles.selectPiker, styles.dropdown)}
                    // disabled="true"
                    disabled={disableEditTripSchedule}
                  >
                    {minsArray.map((item, pos) => (
                      <option key={pos} value={item.value}>
                        {item.min}
                      </option>
                    ))}
                  </select>
                ) : (
                  <select
                    {...register("endMin", { required: true })}
                    className={cn(styles.selectPiker, styles.dropdown)}
                  >
                    <option hidden></option>
                    {minsArray.map((item, pos) => (
                      <option key={pos} value={item.value}>
                        {item.min}
                      </option>
                    ))}
                  </select>
                )}
              </div>
              <div className={cn(styles.time)}>
                {addclick !== "addData" &&
                props?.chargetrip === "Trip Schedule" ? (
                  unitsSystem === "metric" ? (
                    ""
                  ) : (
                    <select
                      {...register("eAmPm", { required: false })}
                      className={cn(styles.selectPiker, styles.dropdown)}
                      // disabled="true"
                      disabled={disableEditTripSchedule}
                    >
                      {/* {unitsSystem === 'metric' ? '' : */}
                      <>
                        <option value="am">AM</option>
                        <option value="pm">PM</option>
                      </>
                      {/* } */}
                    </select>
                  )
                ) : unitsSystem === "metric" ? (
                  ""
                ) : (
                  <select
                    {...register("eAmPm", { required: true })}
                    className={cn(styles.selectPiker, styles.dropdown)}
                  >
                    <option hidden></option>
                    {/* {unitsSystem === 'metric' ? '' : */}
                    <>
                      <option value="am">AM</option>
                      <option value="pm">PM</option>
                    </>
                    {/* } */}
                  </select>
                )}
              </div>
              {(errors.endHours || errors.endMin || errors.eAmPm) && (
                <h2 className={cn(styles.error)}> {arrivalTimeRequired} </h2>
              )}
              {arrivalTimeError !== "" && (
                <h2 className={cn(styles.error, styles.textCenterAlign)}>
                  {arrivalTimeError}
                </h2>
              )}
            </div>
          </div>

          <div
            className={
              props.chargetrip === "Charging Schedule"
                ? cn(styles.displayNone)
                : cn(styles.flexcontainer)
            }
          ></div>
          <div
            className={
              props.chargetrip === "Charging Schedule"
                ? cn(styles.displayNone)
                : cn(styles.flexcontainer)
            }
          >
            <div
              className={
                addclick !== "addData" && props?.chargetrip === "Trip Schedule"
                  ? cn(styles.tripRadioContainerView)
                  : cn(styles.block1)
              }
            ></div>
            <div className={cn(styles.block2)}>
              {/* {props.chargetrip !== 'Charging Schedule' ? <> */}
              <h2>Desired charge level </h2>
              <h2>
                Estimated Range: {milege}.00{" mi"}{" "}
              </h2>
              {/* </> : ''} */}
            </div>
            <div className={cn(styles.block2)}></div>
          </div>
          <div
            className={
              props.chargetrip === "Charging Schedule"
                ? cn(styles.displayNone)
                : cn(styles.flexcontainer)
            }
          >
            <div
              className={
                addclick !== "addData" && props?.chargetrip === "Trip Schedule"
                  ? cn(styles.tripRadioContainerView)
                  : cn(styles.block4)
              }
            ></div>
            <div className={cn(styles.block3, styles.paddingRight)}>
              {/* {props.chargetrip !== 'Charging Schedule' ? <> */}
              <img
                className={cn(styles.marBottom)}
                src={require("assets/car.png").default}
                alt="carImage"
              />
              <h2 className={cn(styles.textPrecentage)}>
                {percentSteps > 99 ? 100 : percentSteps}%
              </h2>
              <Controller
                control={control}
                name="sliderVal"
                rules={{ required: true }}
                render={({ field }) => (
                  <Slider
                    // {...register("sliderVal", { required: false })}
                    // value={percentage}
                    // onChange={(val) => setProgressValue(val)}
                    onChange={(val) => {
                      field.onChange(val);
                      setProgressValue(val);
                    }}
                    value={field.value}
                    {...sliderProps}
                    disabled={
                      addclick !== "addData" &&
                      props?.chargetrip === "Trip Schedule"
                        ? // ? true
                          disableEditTripSchedule
                        : false
                    }
                  />
                )}
              />
              {/* </>
                                : '' */}
              {/* } */}
              {percentageError !== "" && (
                <h2 className={cn(styles.error, styles.normalFont)}>
                  {" "}
                  {desiredChargedLevelRequired}{" "}
                </h2>
              )}
              {errors.sliderVal && (
                <h2 className={cn(styles.error, styles.normalFont)}>
                  {" "}
                  {desiredChargedLevelRequired}{" "}
                </h2>
              )}
            </div>
          </div>
          <div className={cn(styles.flexcontainer)} />
          <div className={cn(styles.flexcontainer)}>
            <div
              className={
                addclick !== "addData" && props?.chargetrip === "Trip Schedule"
                  ? cn(styles.tripRadioContainerView)
                  : cn(styles.block4)
              }
            />

            <div className={cn(styles.block3, styles.paddingRight)}>
              <div
                className={
                  addclick !== "addData" &&
                  props?.chargetrip === "Trip Schedule"
                    ? cn(styles.textRightView)
                    : cn(styles.textRight)
                }
              >
                {addclick !== "addData" ? (
                  <span
                    className={cn(styles.btnDelete)}
                    onClick={() =>
                      disableEditTripSchedule
                        ? setDisableEditTripSchedule(false)
                        : editTripSchedule()
                    }
                  >
                    {" "}
                    {disableEditTripSchedule ? "Edit" : "Update"}
                  </span>
                ) : (
                  ""
                )}

                {addclick !== "addData" ? (
                  <span
                    className={cn(styles.btnDelete)}
                    onClick={() => deleteSchedule("delete")}
                  >
                    {" "}
                    Delete
                  </span>
                ) : (
                  ""
                )}
                <button
                  className={cn(styles.btnCancelAdd)}
                  onClick={() => closeP()}
                >
                  Close
                </button>
                {addclick !== "addData" &&
                props?.chargetrip === "Trip Schedule" ? (
                  ""
                ) : (
                  <button
                    type="submit"
                    className={cn(styles.btnCreate)}
                    disabled={
                      addclick !== "addData" &&
                      props.chargetrip !== "Charging Schedule"
                        ? true
                        : false
                    }
                  >
                    {addclick === "addData" ? "Save" : "Update"}{" "}
                  </button>
                )}
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
export default TripPopup;
